import {BaseDTO} from '../../common/models/BaseDTO';
import {BankAccountDTO} from './BankAccountDTO';

export class BankAccountLinkDTO extends BaseDTO {
  bankAccount: BankAccountDTO;
  startDate: Date;
  endDate: Date;
}
